


























import { GREEN, REASON, REASONS, RED } from "@/resources/constants/busyReasons";
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import { MIX_PANEL_CONSTANTS } from "@/resources/constants/mixpanel";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
Component({
  name: "reason-selector-component",
  directives: { ClickOutsideDirective },
});
export default class ReasonSelectorComponent extends mixins(
  FloatMenuAnimation
) {
  REASONS = REASONS;
  get spaceUser(): SpaceUserInterface {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  selectReason(value: number): void {
    if (value !== 8) {
      if (
        REASON.TYPE_REASON_VACATION ==
        this.REASONS.filter((a) => a.id === value)[0].type
      ) {
        this.$store?.dispatch("SystemStore/setVacationModalAction", true);
        return;
      }
      const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
      this.$store.dispatch("UserStore/updateUserStatusAction", {
        userId: spaceUser.superSpaceUser.user.id,
        props: {
          availableStatus: value == 1 ? GREEN.type : RED.type,
          availableStatusReason:
            value == 1 || value == 2
              ? null
              : this.REASONS.filter((a) => a.id === value)[0].type,
          emoji:
            value == 1
              ? localStorage.getItem("default_emoji")
              : this.REASONS.filter((a) => a.id === value)[0].code,
        },
        callback: (user) => {
          const space = this.$store.getters["SpaceStore/getSpace"];
          this.$mixpanel.track(MIX_PANEL_CONSTANTS.STATE_OFF, {
            distinct_id: spaceUser.superSpaceUser.user.id,
            "State type": this.REASONS.filter((a) => a.id === value)[0].type,
            "Space ID": space.id || null,
            "Space Name": space.name || null,
            "Space Type": space.type || null,
            "Scenario Name": space.scenario.scenarioType.name || null,
            "Super Space Name": space.superSpace.name || null,
            "Super Space ID": space.superSpace.id || null,
          });
          this.$store.dispatch("SpaceStore/updateUserInSpace", user);
          this.close();
        },
        callbackError: (error) => {
          console.log("availableStatusReason ", error);
          this.close();
        },
      });
    } else this.$store.dispatch("SidebarStore/setOpenOtherReasonAction", true);
  }
  close() {
    setTimeout(() => {
      this.closeReasonSelector();
    }, 50);
    setTimeout(() => {
      this.$store.dispatch("FloatMenuStore/setOpenReasonSelectorAction", false);
    }, 200);
  }
}
